module.exports = __webpack_public_path__ + "static/media/ic_nav_02.81c35b1c.svg";